import React, { useState, useEffect } from "react";
import {
  Box,
  Container,
  Stack,
  Fade,
} from "@mui/material";
import NavBar from "../../../Components/NavBar";
import { colors } from "../../../../theme";
import { CommonBreadcrumbs } from "../../../Components/ui";
import { Path } from "../../../../static/Constants";

import {
  AboutHero,
  AboutPillars,
  AboutGameEngines,
  AboutEcosystemRoles,
  AboutCtaCard,
  AboutHeroSkeleton,
  AboutPillarsSkeleton,
} from "./components";

import "./AboutStyles.css";

const About = () => {
  const [isLoading, setIsLoading] = useState(true);

  // Initialize and complete loading with safeguard timeout (never stuck on loader)
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 200);

    return () => clearTimeout(timer);
  }, []);

  return (
    <Box
      id="aboutScreen"
      sx={{
        bgcolor: colors.dashboard.canvas,
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <NavBar />

      <Container
        maxWidth="lg"
        sx={{
          pt: { xs: "96px", sm: "108px", md: "116px" },
          pb: 8,
          flexGrow: 1,
        }}
      >
        {/* Breadcrumb Navigation */}
        <CommonBreadcrumbs
          items={[
            { label: "Home", path: Path.root },
            { label: "About Us" },
          ]}
        />

        {isLoading ? (
          <Stack spacing={4}>
            <AboutHeroSkeleton />
            <AboutPillarsSkeleton />
          </Stack>
        ) : (
          <Fade in timeout={300}>
            <Stack spacing={4}>
              {/* Hero Banner with Vision, Mission & Key Statistics */}
              <AboutHero />

              {/* Core 6 Architectural Pillars */}
              <AboutPillars />

              {/* Proprietary 4 Smart Contract Game Engines */}
              <AboutGameEngines />

              {/* Stakeholder Ecosystem Roles: Players, Creators, Partners */}
              <AboutEcosystemRoles />

              {/* Bottom CTA Banner */}
              <AboutCtaCard />
            </Stack>
          </Fade>
        )}
      </Container>
    </Box>
  );
};

export default About;
